import React, { useEffect, useState } from "react";

import { buttonVariants } from "./button";
import { useIndexedDB } from "@/lib/hooks/useIndexedDb";
import { BOOKMARK_DB_NAME, BOOKMARK_TABLE_NAME } from "@/lib/constants";
import ToolTipNavItem from "./tooltip-nav-item";

function QuranAyahLike({ id }: { id: string | number }) {
  const [heart, setHeart] = useState(false);
  const { saveRecord, getRecord, isDBConnecting, deleteRecord } = useIndexedDB<{
    id: string | number;
    bookmarked: boolean;
  }>(BOOKMARK_DB_NAME, [BOOKMARK_TABLE_NAME]);

  async function findRecord() {
    const record = await getRecord(BOOKMARK_TABLE_NAME, id as number);
    if (record) setHeart(true);
    return record;
  }

  const handleLikeAyah = async () => {
    const record = await findRecord();

    // delete the record
    if (record) deleteRecord(BOOKMARK_TABLE_NAME, id as string);
    // save the record
    else saveRecord(BOOKMARK_TABLE_NAME, { id: id, bookmarked: true });

    setHeart((heart) => !heart);
  };

  useEffect(() => {
    if (!isDBConnecting) findRecord();
  }, [isDBConnecting, id]);

  return (
    <ToolTipNavItem tooltipText="Bookmark Ayah" direction="top">
      <div
        className={`${buttonVariants({
          variant: "bgGhost",
        })} h-9 w-9 p-0 cursor-pointer`}
        onClick={handleLikeAyah}
      >
        {/* <Heart className="w-5 h-5" /> */}
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          className="w-5 h-5"
        >
          <path
            fill={heart === true ? "currentColor" : " "}
            d="M19 14c1.49-1.46 3-3.21 3-5.5A5.5 5.5 0 0 0 16.5 3c-1.76 0-3 .5-4.5 2-1.5-1.5-2.74-2-4.5-2A5.5 5.5 0 0 0 2 8.5c0 2.3 1.5 4.05 3 5.5l7 7Z"
          ></path>
        </svg>
      </div>
    </ToolTipNavItem>
  );
}

export default QuranAyahLike;
